export default {"src":"/_next/static/media/correct_answer.b05fe9c4.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};